import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["statusText"];
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { jsx as _jsx } from "react/jsx-runtime";
export const NotificationStatusRibbon = _ref => {
  let {
      statusText
    } = _ref,
    ribbonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!statusText) {
    return null;
  }
  return /*#__PURE__*/_jsx(Ribbon, Object.assign({
    use: "calypso",
    position: "left"
  }, ribbonProps, {
    children: statusText
  }));
};